import { memo, useEffect, useState } from 'react';
import type { NodeProps } from 'reactflow';
import { FastForward, CheckCircle, XCircle, Clock } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const FlowRunnerNode = ({ data, selected }: NodeProps) => {
    const [status, setStatus] = useState<string>(data.status || 'idle');
    const [flowName, setFlowName] = useState<string>('Select Flow...');

    useEffect(() => {
        if (data.flowName) setFlowName(data.flowName);
        else if (data.label && data.label !== 'Run Flow') setFlowName(data.label);
    }, [data.flowName, data.label]);

    useEffect(() => {
        if (data.status) setStatus(data.status);
    }, [data.status]);

    return (
        <BaseNodeUI
            title={flowName}
            icon={FastForward}
            colorClass=""
            bgClass="bg-rose-100/50 hover:border-rose-300"
            selected={selected}
            isSource={true}
            isTarget={true}
            isRunning={status === 'running'}
        >
            {status !== 'idle' && (
                <div className={`
                    absolute -top-2 -right-2 p-1 rounded-full border shadow-sm z-30
                    ${status === 'success' ? 'bg-emerald-100 text-emerald-600 border-emerald-200' :
                        status === 'error' ? 'bg-red-100 text-red-600 border-red-200' :
                            status === 'running' ? 'bg-blue-100 text-blue-600 border-blue-200' : 'hidden'}
                `}>
                    {status === 'success' ? <CheckCircle size={12} strokeWidth={3} /> :
                        status === 'error' ? <XCircle size={12} strokeWidth={3} /> :
                            status === 'running' ? <Clock size={12} strokeWidth={3} className="animate-spin" /> : null}
                </div>
            )}
            {/* Small pill for Mode */}
            <div className={`
                absolute bottom-1 right-1 text-[8px] font-bold px-1.5 py-0.5 rounded-full border
                ${data.waitMode === 'fireAndForget' ? 'bg-blue-50 text-blue-600 border-blue-100' : 'bg-slate-50 text-slate-500 border-slate-100'}
            `}>
                {data.waitMode === 'fireAndForget' ? 'ASYNC' : 'SYNC'}
            </div>
        </BaseNodeUI>
    );
};

export default memo(FlowRunnerNode);
